// extracted by mini-css-extract-plugin
export default {"app":"RootLayout_app__Wp14i","main":"RootLayout_main__y0yxM"};